<script>
import { MESSAGE_TYPE } from '../models/message'

import { mapGetters } from 'vuex'

export default {
  name: 'Message',

  props: {
    message: Object
  },

  computed: {
    ...mapGetters([
      'user',
      'usernameColor',
      'showMessageTime',
      'backendErrorText',
      'usernameLinkTextColor',
      'usernameLinkBackground'
    ])
  },

  render: function (createElement) {
    let innerElements = []
    if (this.showMessageTime) {
      let timestamp = createElement('small', {
        attrs: {
          class: 'text-muted'
        }
      }, [ `${this.message.timestamp} ` ])
      innerElements.push(timestamp)
    }

    if (this.message.from) {
      let from = createElement('b', {
        style: {
          color: this.message.data.settings.usernameColor
        }
      }, [ `${this.message.from}: ` ])
      innerElements.push(from)
    }

    let text = ''
    switch (this.message.type) {
      case MESSAGE_TYPE.BROADCAST:
        let innerText = []
        const messageText = this.message.data.text
        const linkToUsername = `@${this.user}`
        if (messageText.indexOf(linkToUsername) !== -1) {
          const messageChunks = messageText.split(linkToUsername)
          messageChunks.forEach((chunk, i, array) => {
            innerText.push(chunk)
            if (i !== messageChunks.length - 1) {
              innerText.push(createElement('span', {
                style: {
                  backgroundColor: this.usernameLinkBackground,
                  color: this.usernameLinkTextColor
                },
                attrs: {
                  class: 'message-user-link'
                }
              }, [ linkToUsername ]))
            }
          })
        } else {
          innerText.push(messageText)
        }
        text = createElement('span', {
          attrs: {
            class: 'message-text'
          }
        }, innerText)
        break
      case MESSAGE_TYPE.ERROR:
        text = createElement('i', {
          attrs: {
            class: 'text-muted'
          }
        }, [ this.backendErrorText(this.message.data.text) ])
        break
    }
    innerElements.push(text)

    return createElement('div', { attrs: { class: 'message' } }, innerElements)
  }
}
</script>

<style lang="scss" scoped>
.message:not(:last-child) {
  margin-bottom: 5px;
}

.message {
  &-text {
    word-wrap: break-word;
  }

  &-user-link {
    border-radius: 3px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Message.vue